export async function requestPushPermissions(): Promise<void> {
  // We don't currently support push permissions on web.
  return Promise.resolve()
}
